import { render, staticRenderFns } from "./VenueSync.vue?vue&type=template&id=70a0f220&scoped=true&"
import script from "./VenueSync.vue?vue&type=script&lang=js&"
export * from "./VenueSync.vue?vue&type=script&lang=js&"
import style0 from "./VenueSync.vue?vue&type=style&index=0&id=70a0f220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0f220",
  null
  
)

export default component.exports